import * as React from 'react';
import { alpha } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import { ThemeLabel, ThemeInput, ThemeFilledText } from './Controls';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MENU_ITEMS = 4.3;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * MENU_ITEMS + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// チェックボックス付きセレクト
export const CheckSelect = (props) => {
  const [value, setValue] = React.useState([]);

  React.useEffect(() => {
    // 配列の場合
    if (props != null && Array.isArray(props.value)) {
      setValue(props.value);
    }
    else {
      // 値設定
      setValue([])
    }
  }, [props.value]);

  // 値変更
  const handleChange = (event) => {
    let newValue = event.target.value;
    // MUI multiple Select は配列を返すが、念のため文字列->分割対応
    if (typeof newValue === 'string') newValue = newValue.split(',');
    if (!Array.isArray(newValue)) newValue = [newValue];
    setValue(newValue);
  };

  // レンダリング
  return (
    <FormControl variant="standard" fullWidth>
      <ThemeLabel shrink htmlFor={props.id} id={`${props.id}_label`}>{props.label}</ThemeLabel>
      <Select
        labelId={`${props.id}_label`}
        id={props.id}
        multiple
        value={value}
        onChange={handleChange}
        input={<ThemeInput id={props.id} {...props.register(props.id)}/>}
        MenuProps={MenuProps}
        displayEmpty={true}
        renderValue={(selected) => {
          if (!Array.isArray(selected) || selected.length === 0) {
            return <Typography textAlign="left" fontSize={14} color={alpha("#000", 0.35)}>{props.placeholder}</Typography>;
          }
          const names = selected.map((id) => {
            const opt = props.options.find((option) => String(option.id) === String(id));
            return opt ? opt.name : id;
          });
          return <>{names.join(', ')}</>;
        }}
      >
        {props.options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox size="small" checked={value.includes(option.id)} />
            <ListItemText primary={option.name} />
          </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
}

export const CheckFilledSelect = (props) => {
  const [value, setValue] = React.useState([]);

  React.useEffect(() => {
    // 配列の場合
    if (props != null && Array.isArray(props.value)) {
      setValue(props.value);
    }
    else {
      // 値設定
      setValue([])
    }    
  }, [props.value]);

  // 値変更
  const handleChange = (event) => {
    let newValue = event.target.value;
    if (typeof newValue === 'string') newValue = newValue.split(',');
    if (!Array.isArray(newValue)) newValue = [newValue];
    setValue(newValue);
  };

  return (
    <FormControl variant="standard" fullWidth>
      <ThemeFilledText variant="standard" id={props.id} label={props.label} {...props.register(props.id)}
        select
        slotProps={{
          input: {
            startAdornment: <InputAdornment position="start" sx={{mx:0}}></InputAdornment>,
            endAdornment: <InputAdornment position="end" sx={{mx:1}}></InputAdornment>
          },
          select: {
            multiple: true,
            value: value,
            onChange: (e) => handleChange(e),
            MenuProps: MenuProps,
            displayEmpty: true,
            renderValue: (selected) => {
              if (!Array.isArray(selected) || selected.length === 0) {
                return <Typography textAlign="left" fontSize={14} color={alpha("#000", 0.35)}>{props.placeholder}</Typography>;
              }
              const names = selected.map((id) => {
                const opt = props.options.find((option) => String(option.id) === String(id));
                return opt ? opt.name : id;
              });
              return <>{names.join(', ')}</>;
            },
          },
        }}
      >
        {props.options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox size="small" checked={value.includes(option.id)} />
            <ListItemText primary={option.name} />
          </MenuItem>
          ))
        }
      </ThemeFilledText>
    </FormControl>
  );
}
